import { ApiClientService } from '@dfl/react-security';
import { AnalyticService } from './analytic.service';

class UsersAnalyticService extends AnalyticService<any> {
  usersSummary = (params: any = {}): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/users/users-summary'), params)).then((data) =>
      data?.length ? data[0] : data,
    );
  };

  usersHistogram = (params: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/users/users-histogram'), params));
  };

  usersTopBuyersByPurchaseAmount = (params: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/orders/orders-top-users'), params));
  };

  usersTopBuyersByPurchaseAmountTable = (params: any, config: any): Promise<any> => {
    const size = params?.size || 20;
    return this.handleSearchResponse(
      ApiClientService.post(this.getPath('/orders/orders-top-users'), { ...params, ...config }, config),
      size,
    );
  };

  involvedUsersCount = (params: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/orders/orders-involved-users'), params)).then(
      (data) => (data?.length ? data[0] : data),
    );
  };

  involvedUsersCountRanges = (params: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/orders/orders-range-involved-users'), params))
      .then((data) => (data?.length ? data[0] : data))
      .then((data) =>
        Object.keys(data)?.reduce((r: any[], e) => {
          r.push({ interval: e, count: data[e] });
          return r;
        }, []),
      );
  };
}

export default new UsersAnalyticService('/ms-auth/api/aggregate');
